import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';

import { AuthTokenService } from '@core/authentication/auth-token.service';
import { RoleTypes } from '@core/authentication/shared/role-types.enum';
import { ReportRouter } from '@core/routers/report-router.enum';

@Injectable()
export class LayoutDefaultGuardService implements CanLoad, CanActivate {
    constructor(
        private authTokenService: AuthTokenService,
        private router: Router,
    ) { }

    public canActivate(): boolean {
        return this.canLoad();
    }

    public canLoad(): boolean {
        // tslint:disable-next-line:no-bitwise
        if (this.authTokenService.role & RoleTypes.Partners) {
            this.router.navigate([ReportRouter.StandardReports]);

            return false;
        }

        return true;
    }
}
